import { redirectActiveSignupOnboardingSession } from 'app/onboarding/v2/_lib/pages-router-guard';
import PersonalCardsPreviewPage from 'app-next/[workspace]/cards/personal/[cardId]/preview/page';
import type { GetServerSideProps } from 'next';
import type { NextPageWithLayout } from 'pages/_app';

const page: NextPageWithLayout = PersonalCardsPreviewPage;

export default page;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  return (await redirectActiveSignupOnboardingSession(ctx)) ?? { props: {} };
};
